import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { resolveQRUrl, getRestaurantMenu } from '../api/client';
import { getTemplateComponent } from '../templates/TemplateRegistry';
import { normalizeMenuData } from '../utils/normalizeMenuData';

const QRResolver = () => {
    const { shortcode } = useParams();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [templateName, setTemplateName] = useState(null);
    const [menuData, setMenuData] = useState(null);

    useEffect(() => {
        const fetchData = async () => {
            try {
                setLoading(true);
                setError(null);

                // 1. Resolve URL to get Template Name
                const resolveData = await resolveQRUrl(shortcode);
                setTemplateName(resolveData.templateName);

                // 2. Fetch Menu Data
                const data = await getRestaurantMenu(shortcode);
                setMenuData(data);
            } catch (err) {
                console.error("Failed to load menu", err);
                setError("Unable to load menu. Please try again or scan the QR code again.");
            } finally {
                setLoading(false);
            }
        };

        if (shortcode) {
            fetchData();
        }
    }, [shortcode]);

    if (loading) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                color: '#666'
            }}>
                Loading Menu...
            </div>
        );
    }

    if (error) {
        return (
            <div style={{
                padding: '20px',
                textAlign: 'center',
                color: '#e74c3c',
                marginTop: '50px'
            }}>
                <h2>Oops!</h2>
                <p>{error}</p>
                <Link to="/" style={{ color: '#3498db', textDecoration: 'none', display: 'block', marginTop: '20px' }}>
                    ← Back to Dashboard
                </Link>
            </div>
        );
    }

    // Render the resolved template
    const TemplateComponent = getTemplateComponent(templateName);

    // Normalize backend responses where a raw `restaurant` object may be returned
    // instead of the `{ restaurant, menus }` structure expected by templates.
    let normalizedData = menuData;
    if (normalizedData && !normalizedData.menus && (normalizedData.id || normalizedData.name)) {
        normalizedData = { restaurant: normalizedData, menus: [] };
        // eslint-disable-next-line no-console
        console.warn('QRResolver: normalized menuData to expected shape', menuData);
    }

    // Normalize nested structures (tags as objects -> strings, variants shape, etc.)
    if (normalizedData) {
        try {
            normalizedData = normalizeMenuData(normalizedData);
        } catch (e) {
            // eslint-disable-next-line no-console
            console.warn('QRResolver: failed to normalize menuData', e);
        }
    }

    return <TemplateComponent data={normalizedData} />;
};

export default QRResolver;
